module.exports = __webpack_public_path__ + "img/img_logo.eadb71b1.png";